<div class="map">
  <img [src]="mapImageSrc" alt="" class="map--image" #mapImage>
  <img [src]="markerImageSrc" class="map--marker" alt="">
  <a [href]="directionsUrl" class="btn btn-primary map--button" target="_blank" (click)="trackCalculateRouteClick($event)" translate>detail.map.calculateRoute</a>
</div>
